import styled from 'styled-components';
import { NSOnline } from './NetworkStatusComponents';
export const ErrorDisplay = () => {
  return (
    <ErrorContainer>
      <NSOnline>
        <h1>Something went wrong</h1>
        <p>Please refresh the page - something's broken.</p>
        <p>
          You can file a bug report{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://forms.gle/D1pjw7hvSJiHNcmu9"
          >
            here.
          </a>{' '}
        </p>
      </NSOnline>
    </ErrorContainer>
  );
};
const ErrorContainer = styled.div`
  padding: 5vw;
`;
